export default __webpack_public_path__ + "static/media/gravitricityConcept.f10162fd.png";